
import { FIELD_TYPE, REFDATA_MAP, DATE_FORMAT, CHOOSE_DATE } from '@/constants'

import authorizationRefDetails from './helper/authorizationRefDetails'
import authorizationHelperDetails from './helper/authorizationHelperDetails'


export default [  
  {
    label: 'Authorization',   
    type: FIELD_TYPE.HEADING
  },

  authorizationRefDetails,
  
  {
    apiKey: 'authorization.refSign',
    label: 'Write your Name for Signature',
    required: true,
    type: FIELD_TYPE.NAME
  },

  authorizationHelperDetails
 
  
]